__turbopack_context__.v({
  "container": "CarouselButton-module-scss-module__J2fU_G__container",
  "root": "CarouselButton-module-scss-module__J2fU_G__root",
});
